<template>
  <div class="park_switch" @click="changeState">
    <i class="el-icon-location-outline"></i>
    <!-- 当前活动园区 -->
    <span class="park_name" v-if="parkInfo">{{parkInfo.name}}</span>
    <i :class="{'el-icon-caret-bottom':state,'el-icon-caret-top':!state}"></i>

    <!-- 企业列表 -->
    <transition name="fade">
      <ul class="one" v-if="list.length && state">
        <li v-for="item in list" :key="item.id" @click.stop="getPark(item)">{{item.name}}</li>
      </ul>
    </transition>
    <!-- 园区列表 -->
    <transition name="fade">
      <ul class="two" v-if="list2.length && state">
        <li v-for="item in list2" :key="item.id" @click.stop="selcetPark(item)">{{item.name}}</li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        enterprise_id: "",
        incubator_id: ""
      },
      list: [], //企业
      list2: [], //园区
      state: false
    };
  },
  computed: {
    parkInfo() {
      return this.$store.state.parkInfo;
    }
  },
  created() {
    this.getUserEnterprise();
  },
  methods: {
    //   切换状态
    changeState() {
      this.state = !this.state;
      this.list2 = [];
    },
    //查询已认证企业
    getUserEnterprise() {
      this.api.getUserEnterprise().then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list || [];
        this.list = list;
      });
    },
    //选择企业
    getPark(item) {
      this.form.enterprise_id = item.id;
      this.getIncubators();
    },
    // 根据企业查询园区
    getIncubators() {
      let params = {
        enterprise_id: this.form.enterprise_id,
        pageNo: 0,
        pageSize: 99
      };
      this.api.getUserIncubator(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list2 = res.obj.list || [];
        this.list2 = list2;
      });
    },
    // 切换当前活动园区
    selcetPark(item) {
      this.form.incubator_id = item.id;
      this.setUserSelectIncubator();
    },
    // 切换当前企业园区
    setUserSelectIncubator() {
      let params = {
        enterprise_id: this.form.enterprise_id,
        incubator_id: this.form.incubator_id
      };
      this.api.setUserSelectIncubator(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.common.getParkInfo(true);
        this.$message.success('已切换园区');
        this.changeState();
         window.location.reload(true);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.park_switch {
  display: flex;
  align-items: center;
  width: 120px;
  height: 64px;
  position: relative;
  cursor: pointer;
  user-select: none;
  .park_name {
    font-size: 16px;
    width: 100px;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 6px;
    padding: 5px 0;
  }
  i {
    color: #999;
  }
  ul {
    position: absolute;
    border: 1px solid #eee;
    border-bottom: 0;
    z-index: 111;
    background: #fff;
  }
  .one {
    top: 64px;
  }
  .two {
    left: 305px;
    top: 64px;
  }
  li {
    width: 303px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    background: #fff;
    font-size: 14px;
    color: #333;
    text-indent: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
      background: rgba(17, 126, 255, 0.1);
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>